// extracted by mini-css-extract-plugin
module.exports = {"Icon":"SocialIcon_Icon__2A93W"};